<script>
export default {
  methods: {
    validatePassword() {
      // only set error if we show password field
      this.$nextTick(() => {
        if (!this.isLoggedIn) {
          if (!this.$refs.password?.validate) {
            this.$set(
              this.errors,
              'password',
              'Password must be at least 6 characters long (up to 50 characters supported).',
            );
          } else {
            this.$delete(this.errors, 'password');
          }
        }
      });
    },
  },
};

</script>
